export default __webpack_public_path__ + "static/media/logo192.32e5ebbf.png";